module.exports = __webpack_public_path__ + "assets/img/5_1360.61f6983d.jpg";